import React from 'react';
import { Select, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useI18n, LANGS } from '../i18n/I18nContext';

export default function LanguageSwitcher() {
  const { lang, setLang } = useI18n();
  return (
    <Select
      value={lang}
      onChange={(e) => setLang(e.target.value)}
      size="small"
      variant="standard"
      disableUnderline
      startAdornment={<LanguageIcon sx={{ fontSize: 18, mr: 0.5, opacity: 0.7 }} />}
      renderValue={(code) => code.toUpperCase()}
      sx={{
        color: 'inherit', fontSize: '0.85rem',
        '& .MuiSelect-select': { py: 0.3, pr: '20px !important' },
        '& .MuiSelect-icon': { color: 'inherit' },
        '&:before, &:after': { display: 'none' },
      }}
      MenuProps={{ PaperProps: { sx: { mt: 1 } } }}
    >
      {LANGS.map(([code, label]) => (
        <MenuItem key={code} value={code} sx={{ fontSize: '0.85rem' }}>
          {label}
        </MenuItem>
      ))}
    </Select>
  );
}
